<article class="card h-100 shadow-sm" [attr.aria-label]="accessibleSummary">
  <div class="card-body d-flex flex-column p-3 p-md-4">
    <div
      class="d-flex flex-wrap align-items-start justify-content-between gap-2 mb-1"
    >
      <h3 class="h5 fw-bold mb-0">{{ result.platformName }}</h3>
      <span
        class="badge border fw-normal"
        [ngClass]="evidenceBadgeClasses(result.evidence.status)"
      >
        {{ result.evidence.label }}
      </span>
    </div>

    <p class="small fw-semibold text-body-secondary mb-3">
      {{ costModelSummary }}
    </p>

    <p class="text-uppercase small text-body-secondary fw-semibold mb-1">
      Organization receives
    </p>
    <p class="h2 fw-bold text-primary mb-3">
      {{ formatMoney(row.organizationReceivesCents) }}
    </p>
    <p *ngIf="row.costsExceedDonationsCents > 0" class="small text-danger mb-3">
      Costs exceed donations by
      {{ formatMoney(row.costsExceedDonationsCents) }}.
    </p>

    <dl class="row g-2 small mb-0">
      <ng-container *ngIf="usesRevenueShare">
        <dt class="col-7 fw-normal text-body-secondary">Organization keeps</dt>
        <dd class="col-5 text-end fw-semibold mb-0">
          {{ organizationRetainedPercentage }}
        </dd>
      </ng-container>

      <dt class="col-7 fw-normal text-body-secondary">
        {{ organizationCostLabel }}
      </dt>
      <dd class="col-5 text-end fw-semibold mb-0">
        {{ formatMoney(result.organizationCostCents) }}
      </dd>

      <ng-container *ngIf="showSupporterExtra">
        <dt class="col-7 fw-normal text-body-secondary">
          {{ supporterExtraLabel }}
        </dt>
        <dd
          class="col-5 text-end mb-0"
          [class.fw-semibold]="result.donorPaidExtraEstimated"
        >
          {{ supporterExtraValue }}
        </dd>
      </ng-container>
    </dl>

    <button
      type="button"
      class="btn btn-outline-primary btn-sm mt-3 align-self-start"
      data-bs-toggle="offcanvas"
      data-bs-target="#fundraisingPlatformQuickView"
      aria-controls="fundraisingPlatformQuickView"
      [attr.aria-label]="'Configure ' + result.platformName"
      (click)="quickViewRequested.emit(result.platformId)"
    >
      Configure
      <span aria-hidden="true">›</span>
    </button>

    <a
      *ngIf="row.detailPageUrl"
      class="btn btn-link px-0 mt-auto pt-3 text-start fw-semibold"
      [href]="row.detailPageUrl"
      (click)="detailLinkClicked.emit(result.platformId)"
    >
      View pricing &amp; scenarios
      <span aria-hidden="true">→</span>
    </a>
  </div>
</article>
